import {useContext, useEffect, useState} from 'react'
import {ReducerContext} from '../reducer'

function matchData(dropdown, datum) {
  if (dropdown.orgRole === datum.role && dropdown.rubric === datum.rubric && dropdown.form === datum.form) return true
}

const defaultData = [{date: null, score: null}]

export default function useGraphData() {
  const [data, setData] = useState([])
  const {state, dispatch} = useContext(ReducerContext)

  const {rubric, form, interval = '30_day', aggregation, fieldUser, reviewer, installerUser} = state.dropdown

  // Converts projectAverages to the form that the graph wants
  useEffect(
    function () {
      if (!rubric || !form) {
        console.log('resetting plot data: missing rubric or form')
        dispatch({type: 'graphData', value: defaultData})
        return
      }

      console.log('Updating plot data... ', {
        interval, 
        aggregation, 
        fieldUser, 
        reviewer,
        installerUser,
        projectAvgsLength: state.projectAvgs?.length
      })
      console.log('Raw projectAvgs:', state.projectAvgs)
      
      // Filter data based on selected aggregation and user
      let filteredData = state.projectAvgs
      
      // If a specific user is selected, filter for that user
      const selectedUser = aggregation === 'reviewer' 
        ? reviewer 
        : aggregation === 'installer'
          ? installerUser
          : fieldUser;

      if (selectedUser && selectedUser !== 'All' && selectedUser !== 'select') {
        console.log('Filtering for specific user:', selectedUser)
        filteredData = filteredData.filter(d => d[aggregation] === selectedUser)
        console.log('Filtered data after user filter:', filteredData)
      }

      console.log('Filtered data:', filteredData)

      const data = filteredData
        .map((d) => {
          const score = d[interval] !== undefined && d[interval] !== null ? parseFloat(d[interval]?.toFixed(3)) : null;
          console.log(`Processing record - date: ${d.date}, ${interval}: ${d[interval]}, score: ${score}, count: ${d[interval + '_count']}`);
          return {
            score: score,
            date: d.date, // Ensure this is in YYYY-MM-DD format
            projects_included: d[interval + '_count'] || 0,
          }
        })
        .filter(d => {
          const isValid = d.score !== null && !isNaN(d.score);
          if (!isValid) {
            console.log('Filtering out invalid score:', d);
          }
          return isValid;
        }) // Filter out null/NaN scores
        .sort((a, b) => new Date(a.date) - new Date(b.date))

      console.log('Final graph data:', data)
      console.log('Final graph data length:', data.length)
      dispatch({type: `graphData`, value: data})
    },
    [rubric, form, state.projectAvgs, interval, aggregation, fieldUser, reviewer, installerUser]
  )

  return data
}
